import Consts from 'Interfaces/Consts';

type Props = {
    componentType: string;
    disptitle: string;
    componentId: string;
    searchInputValue: string;
    handleSubmit: (event) => void;
    onSearchInputChange: (event) => void;
    searchClear: (event) => void;
    toggleOffcanvas: () => void;
    hasSearchInput: boolean;
    totalFiltersSelected: number;
    noFilters: boolean;
};

const SearchAndFilterMobile: React.FC<Props> = ({
    totalFiltersSelected,
    hasSearchInput,
    toggleOffcanvas,
    componentType,
    disptitle,
    handleSubmit,
    onSearchInputChange,
    componentId,
    searchInputValue,
    searchClear,
    noFilters
}) => {


    return (
        <div className="">

            {
                hasSearchInput ?
                    <form
                        id={`Component-Search-${componentId}`}
                        role="search"
                        className={` mst-search-group my-auto d-flex justify-content-between align-items-center`}
                        onSubmit={(e) => handleSubmit(e)}>

                        <label htmlFor={`componentSearchBox-${componentId}`} className="txt-invisible"><span>{Consts.componentSearch}</span></label>

                        <input className={`component-search d-fill ${searchInputValue ? 'with-content' : ''}`}
                            aria-label={disptitle}
                            autoComplete="off"
                            tabIndex={0}
                            type="text"
                            id={`componentSearchBox-${componentId}`}
                            name="search"
                            placeholder={componentType == "Alphon" ? Consts.alphonSearch : Consts.searchTyped}
                            onChange={onSearchInputChange}
                            value={searchInputValue} />

                        <span className={`mst-term-clear ${searchInputValue ? 'term-clear-show' : ''}`} id={`component-search-clear-${componentId}`}>

                            <button className="mst-term-clear-btn " aria-label={Consts.clean} type="button" onClick={(e) => searchClear(e)} onKeyDown={(e) => searchClear(e)}>

                                <span className="mst-term-clear-icon">
                                    <svg aria-hidden="true" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.5L9 9.5" stroke="#3B3B3B" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M9 1.5L1 9.5" stroke="#3B3B3B" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>

                            </button>
                        </span>

                        <div className="">

                            <span className="input-group-btn filters-icon">
                                {
                                    !noFilters &&

                                    <button className="btn mst-btn search-btn" type="button" role="button" onClick={toggleOffcanvas}>

                                        <svg style={{ width: '20px', height: '22px' }} aria-label={Consts.openFiltersSelection} width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M9 16C8.448 16 8 15.552 8 15C8 14.448 8.448 14 9 14C9.552 14 10 14.448 10 15C10 15.552 9.552 16 9 16ZM19 14H11.815C11.401 12.839 10.302 12 9 12C7.698 12 6.599 12.839 6.185 14H1C0.447 14 0 14.447 0 15C0 15.553 0.447 16 1 16H6.185C6.599 17.161 7.698 18 9 18C10.302 18 11.401 17.161 11.815 16H19C19.553 16 20 15.553 20 15C20 14.447 19.553 14 19 14ZM17 10C16.448 10 16 9.552 16 9C16 8.448 16.448 8 17 8C17.552 8 18 8.448 18 9C18 9.552 17.552 10 17 10ZM17 6C15.698 6 14.599 6.839 14.185 8H1C0.447 8 0 8.447 0 9C0 9.553 0.447 10 1 10H14.185C14.599 11.161 15.698 12 17 12C18.654 12 20 10.654 20 9C20 7.346 18.654 6 17 6ZM5 2C5.552 2 6 2.448 6 3C6 3.552 5.552 4 5 4C4.448 4 4 3.552 4 3C4 2.448 4.448 2 5 2ZM1 4H2.185C2.599 5.161 3.698 6 5 6C6.302 6 7.401 5.161 7.815 4H19C19.553 4 20 3.553 20 3C20 2.447 19.553 2 19 2H7.815C7.401 0.839 6.302 0 5 0C3.698 0 2.599 0.839 2.185 2H1C0.447 2 0 2.447 0 3C0 3.553 0.447 4 1 4Z" fill="#3B3B3B" />
                                        </svg>

                                        {
                                            !!totalFiltersSelected &&
                                            <span className="info-bubble">{totalFiltersSelected}</span>
                                        }

                                    </button>
                                }

                            </span>


                            <span className="input-group-btn mst-component-search">
                                <button className="btn mst-btn search-btn" type="submit" role="button"
                                    onClick={(e) => handleSubmit(e)} onKeyDown={(e) => handleSubmit(e)}>
                                    <i className="fa fa-search" aria-label={Consts.componentSearch}></i>
                                </button>
                            </span>

                        </div>

                    </form>
                    :
                    // filter button without search 
                    <div className="input-group-btn container px-0 filters-icon w-100 filters-btn-wrapper">
                        {
                            !noFilters &&

                            <button className="btn border-1" type="button" role="button" onClick={toggleOffcanvas}>

                                <svg style={{ width: '20px', height: '22px' }} aria-label={Consts.openFiltersSelection} width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9 16C8.448 16 8 15.552 8 15C8 14.448 8.448 14 9 14C9.552 14 10 14.448 10 15C10 15.552 9.552 16 9 16ZM19 14H11.815C11.401 12.839 10.302 12 9 12C7.698 12 6.599 12.839 6.185 14H1C0.447 14 0 14.447 0 15C0 15.553 0.447 16 1 16H6.185C6.599 17.161 7.698 18 9 18C10.302 18 11.401 17.161 11.815 16H19C19.553 16 20 15.553 20 15C20 14.447 19.553 14 19 14ZM17 10C16.448 10 16 9.552 16 9C16 8.448 16.448 8 17 8C17.552 8 18 8.448 18 9C18 9.552 17.552 10 17 10ZM17 6C15.698 6 14.599 6.839 14.185 8H1C0.447 8 0 8.447 0 9C0 9.553 0.447 10 1 10H14.185C14.599 11.161 15.698 12 17 12C18.654 12 20 10.654 20 9C20 7.346 18.654 6 17 6ZM5 2C5.552 2 6 2.448 6 3C6 3.552 5.552 4 5 4C4.448 4 4 3.552 4 3C4 2.448 4.448 2 5 2ZM1 4H2.185C2.599 5.161 3.698 6 5 6C6.302 6 7.401 5.161 7.815 4H19C19.553 4 20 3.553 20 3C20 2.447 19.553 2 19 2H7.815C7.401 0.839 6.302 0 5 0C3.698 0 2.599 0.839 2.185 2H1C0.447 2 0 2.447 0 3C0 3.553 0.447 4 1 4Z" fill="#3B3B3B" />
                                </svg>

                                {
                                    !!totalFiltersSelected &&
                                    <span className="info-bubble">{totalFiltersSelected}</span>
                                }
                            </button>
                        }

                    </div>
            }


        </div>

    );

}

export default SearchAndFilterMobile;